import {
  base_colorContentBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const tableCard = css`
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const search = css`
  flex: 1;
`

export const gridWrap = css`
  width: 100%;
`

export const overlay = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  text-align: center;
  padding: ${spacing(8)} ${spacing(4)};
`

export const networkCell = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const networkLogo = css`
  width: 32px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
`

export const seeEnrolledChevron = css`
  width: 16px;
  height: 16px;
  margin-left: ${spacing(1)};
`
